var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-content" },
    [
      _c("p", { attrs: { "aria-labelledby": "targetheading-" + _vm.index } }, [
        _vm._v(_vm._s(_vm.targetSummary.target.name))
      ]),
      _vm._v(" "),
      _c("hr", { staticClass: "mb-2 mt-1" }),
      _vm._v(" "),
      _c("plain-text-control", {
        attrs: { title: "SummaryReport.Results.MetersTitle" }
      }),
      _vm._v(" "),
      !_vm.meters || _vm.meters.length === 0
        ? _c("div", { staticClass: "mb-3" }, [
            _c("span", { staticClass: "font-italic" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "ContinuousReportSummary.Results.TargetSummary.NoMeters"
                  )
                )
              )
            ])
          ])
        : _c(
            "div",
            { staticClass: "meters-list", attrs: { tabindex: "0" } },
            [
              _vm._l(_vm.meters, function(meter, meterIndex) {
                return [
                  _c(
                    "table",
                    {
                      staticClass: "table meters-table",
                      attrs: { role: "presentation" }
                    },
                    [
                      _c("caption", [
                        meter.description
                          ? _c("strong", [_vm._v(_vm._s(meter.description))])
                          : _c("strong", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "Enums.MeterTypeOptions." +
                                        _vm.getMeterTypeKey(meter.type)
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _c("tbody", [
                        _c("tr", [
                          _c("th", { staticClass: "w-25" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ContinuousReportSummary.Results.TargetSummary.Meter.TimeOfMeasurement"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "w-75" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ContinuousReport.Period." + meter.period
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "w-25" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SummaryReport.Results.Meter.MeasurementMethod"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "w-75" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Enums.MeasurementMethodOptions." +
                                    _vm.getMeasurementMethodKey(
                                      meter.measurementMethod
                                    )
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "w-25" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SummaryReport.Results.Meter.AskedCount")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "w-75" }, [
                            _vm._v(_vm._s(meter.askedCount))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "w-25" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SummaryReport.Results.Meter.AnswerCount"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "w-75" }, [
                            _vm._v(_vm._s(meter.answerCount))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("th", { staticClass: "w-25" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "ContinuousReportSummary.Results.TargetSummary.Meter.ChangesInTargetGroups"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "w-75" },
                            _vm._l(meter.targetGroups, function(group) {
                              return _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(group.name) +
                                    "\n                            "
                                )
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2" }, [
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SummaryReport.Results.TargetResultComparison")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    meter.change
                      ? _c("p", [_vm._v(_vm._s(meter.change))])
                      : _c("p", [_vm._v("-")])
                  ]),
                  _vm._v(" "),
                  meterIndex < _vm.meters.length - 1
                    ? _c("hr", { staticClass: "mt-4 mb-3" })
                    : _vm._e()
                ]
              })
            ],
            2
          ),
      _vm._v(" "),
      _vm.targetSummary.operations && _vm.targetSummary.operations.length > 0
        ? _c("operation-summary-tables-control", {
            staticClass: "mb-2",
            attrs: {
              title:
                "ContinuousReportSummary.Results.TargetSummary.Operation.Title",
              operations: _vm.targetSummary.operations
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-area-with-notes-control", {
        attrs: {
          id: "targetSummaryResults_" + _vm.index,
          title:
            "ContinuousReportSummary.Results.TargetSummary.TargetSummaryResults",
          required: "",
          "max-length": 500,
          rows: 5,
          placeholder:
            "ContinuousReportSummary.Results.TargetSummary.TargetSummaryResultsPlaceholder",
          notes: _vm.notesReference,
          buttonTooltip:
            "ContinuousReportSummary.Results.TargetSummary.NotesTooltip"
        },
        model: {
          value: _vm.targetSummary.results,
          callback: function($$v) {
            _vm.$set(_vm.targetSummary, "results", $$v)
          },
          expression: "targetSummary.results"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }